import { type FormState } from 'react-hook-form';

export const hasDirtyFields = (methods: { formState: FormState<any> }) =>
	Object.keys(methods?.formState?.dirtyFields)?.length > 0;
